import React, { useEffect, useState } from "react";
import {
  Container,
  DashboardModule,
  DashboardTop,
  DashboardTopWrapper,
  DashboardContent,
  DashboardGrid,
  Item,
  ItemTopWrapper,
  UlWrapper,
  TasksContainer,
  LoaderContainerDash,
  GridContainer,
} from "./dashboardStyle";
import { dashboardData } from "../../redux/apiCalls";
import styled from "styled-components";
import { ListUl } from "@styled-icons/bootstrap/ListUl";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { MainContainer } from "../../globalStyles";
import { ToastContainer } from "react-toastify";
import Moment from "moment";
import Loader from "../../components/loader/Loader";
const ListUl1 = styled(ListUl)`
  width: 8%;
  height: 8%;
`;
const ListSm = styled(ListUl)`
  width: 6%;
  height: 6%;
`;

const Dashboard = () => {
  const dispatch = useDispatch();
  const { isFetching, error, data } = useSelector((state) => state.dashboard);
  useEffect(() => {
    dashboardData(dispatch, sessionStorage.getItem("accessJWT"));
  }, []);
  const userData = JSON.parse(localStorage.getItem("userInfo"))?.users;
  const dashboardInfo = data?.data;
  return (
    <>
      <MainContainer>
        <DashboardModule>
          <DashboardTop>
            <DashboardTopWrapper>
              <h1>
                WELCOME TO YOUR DASHBOARD,{" "}
                <strong> {userData?.name.toUpperCase()}</strong>{" "}
              </h1>
            </DashboardTopWrapper>
          </DashboardTop>
          <DashboardContent>
            <p>You are now logged in and can perform the tasks below:</p>
          </DashboardContent>
          {isFetching ? (
            <>
              <Loader isFetching={isFetching} />
            </>
          ) : (
            <GridContainer>
              <DashboardGrid>
                <TasksContainer>
                  <Item>
                    <Link className="dashboard-link" to="/tasks/opened_tasks">
                      <ItemTopWrapper>
                        <h1>OPEN TASKS</h1> <ListUl1 />
                      </ItemTopWrapper>
                    </Link>
                  </Item>
                  {dashboardInfo?.dashboardOpenedTasks?.length === 0 ? (
                    <UlWrapper>
                      {" "}
                      <ul>
                        <li>No task is Assigned to You</li>
                      </ul>
                    </UlWrapper>
                  ) : (
                    dashboardInfo?.dashboardOpenedTasks.map((item) => (
                      <UlWrapper>
                        <ul>
                          {" "}
                          <li>
                            <ListSm />
                            &nbsp; &nbsp;
                            <Link
                              to="/task-detail"
                              style={{
                                color: "whiteSmoke",
                                textDecorationLine: "none",
                              }}
                            >
                              {`${Moment(
                                item?.date_assignment.replace(
                                  "T19:00:00.000Z",
                                  "  "
                                )
                              ).format("DD-MM-YYYY")}  Task ID-${
                                item?.task_id
                              }`}
                            </Link>
                          </li>{" "}
                        </ul>
                      </UlWrapper>
                    ))
                  )}
                </TasksContainer>

                <TasksContainer>
                  <Item>
                    <Link className="dashboard-link" to="/tasks/assigned_tasks">
                      <ItemTopWrapper>
                        <h1>ASSIGNED TASKS</h1> <ListUl1 />
                      </ItemTopWrapper>
                    </Link>
                  </Item>
                  {dashboardInfo?.dashboardAssignedTasks?.length === 0 ? (
                    <UlWrapper>
                      {" "}
                      <ul>
                        <li>No task is Assigned to You</li>
                      </ul>
                    </UlWrapper>
                  ) : (
                    dashboardInfo?.dashboardAssignedTasks.map((item) => (
                      <UlWrapper>
                        <ul>
                          {" "}
                          <li>
                            <ListSm />
                            &nbsp; &nbsp;
                            <Link className="dashboard-link" to="/task-detail">
                              {`${Moment(
                                item?.date_assignment.replace(
                                  "T19:00:00.000Z",
                                  ""
                                )
                              ).format("DD-MM-YYYY")} Task ID-${item?.task_id}`}
                            </Link>
                          </li>{" "}
                        </ul>
                      </UlWrapper>
                    ))
                  )}
                </TasksContainer>

                <TasksContainer>
                  <Item>
                    <Link
                      to="/tasks/in_progress_tasks"
                      className="dashboard-link"
                    >
                      <ItemTopWrapper>
                        <h1>IN-PROGRESS TASKS</h1> <ListUl1 />
                      </ItemTopWrapper>
                    </Link>
                  </Item>
                  {dashboardInfo?.dashboardInProgressTasks?.length === 0 ? (
                    <UlWrapper>
                      {" "}
                      <ul>
                        <li> No task is Assigned to You</li>
                      </ul>
                    </UlWrapper>
                  ) : (
                    dashboardInfo?.dashboardInProgressTasks.map((item) => (
                      <UlWrapper>
                        <ul>
                          {" "}
                          <li>
                            <ListSm />
                            &nbsp; &nbsp;
                            <Link
                              to="/task-detail"
                              style={{
                                color: "whiteSmoke",
                                textDecorationLine: "none",
                              }}
                            >
                              {" "}
                              {`${Moment(
                                item?.date_assignment.replace(
                                  "T19:00:00.000Z",
                                  ""
                                )
                              ).format("DD-MM-YYYY")} Task ID-${item?.task_id}`}
                            </Link>
                          </li>{" "}
                        </ul>
                      </UlWrapper>
                    ))
                  )}
                </TasksContainer>

                <TasksContainer>
                  <Item>
                    <Link
                      to="/tasks/completed_tasks"
                      className="dashboard-link"
                    >
                      <ItemTopWrapper>
                        <h1>COMPLETED TASKS</h1> <ListUl1 />
                      </ItemTopWrapper>
                    </Link>
                  </Item>
                  {dashboardInfo?.dashboardCompletedTasks?.length === 0 ? (
                    <UlWrapper>
                      {" "}
                      <ul>
                        <li>No task is Assigned to You</li>
                      </ul>
                    </UlWrapper>
                  ) : (
                    dashboardInfo?.dashboardCompletedTasks.map((item) => (
                      <UlWrapper>
                        <ul>
                          {" "}
                          <li>
                            <ListSm />
                            &nbsp; &nbsp;
                            <Link
                              to="/task-detail"
                              style={{
                                color: "whiteSmoke",
                                textDecorationLine: "none",
                              }}
                            >
                              {`${Moment(
                                item?.date_assignment.replace(
                                  "T19:00:00.000Z",
                                  ""
                                )
                              ).format("DD-MM-YYYY")} Task ID-${item?.task_id}`}
                            </Link>
                          </li>{" "}
                        </ul>
                      </UlWrapper>
                    ))
                  )}
                </TasksContainer>
              </DashboardGrid>
            </GridContainer>
          )}
        </DashboardModule>
        <ToastContainer position="bottom-right" newestOnTop />
      </MainContainer>
    </>
  );
};

export default Dashboard;
